import { Button, Icon } from '@mui/material';
import { RouteEnum } from 'constants/RouteConstants';
import React from 'react';
import { Link } from 'react-router-dom';

const Cookies = ({ setShowCookies, onAddCookies }) => {
  return (
    <div className='fixed bottom-0 z-10 bg-white flex space-x-0 rounded-t-[40px] border px-5 py-10 flex-col space-y-5 lg:space-y-0 lg:py-15 lg:px-24 lg:space-x-32 lg:flex-row'>
      <div className='flex justify-center space-x-3'>
        <div className='mt-1 w-[30%] md:w-[5%]'>
          <Icon>error</Icon>
        </div>
        <h1>
          By clicking <span className='font-bold'>"Accept"</span>, you agree to
          the storing of cookies on your device to enhance site navigation,
          analyze site usage, and assist in our marketing efforts. View our{' '}
          <Link to={RouteEnum.TERMS_AND_CONDITIONS}>
            <u className=' text-primary-main'>Privacy Policy</u>
          </Link>{' '}
          for more information.
        </h1>
      </div>

      <div className=' flex flex-rol justify-center space-y-0 space-x-5 lg:space-x-0 lg:space-y-3 lg:flex-col'>
        <Button onClick={onAddCookies} className='px-10 py-2'>
          Accept
        </Button>
        <Button
          variant='text'
          onClick={() => setShowCookies(false)}
          className='px-11 py-2'
        >
          Reject
        </Button>
      </div>
    </div>
  );
};

export default Cookies;
